import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497bf1d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-title is-title-shrink" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "body-content is-size-4" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 mb-5 is-size-5 notification is-danger is-light"
}
const _hoisted_8 = { class: "custom-card-title has-text-weight-bold" }
const _hoisted_9 = {
  key: 1,
  class: "confirm-icon-container mb-2"
}
const _hoisted_10 = {
  key: 2,
  class: "confirm-icon-container"
}
const _hoisted_11 = {
  key: 3,
  class: "amount custom-card-destinataire has-text-weight-bold is-size-4"
}
const _hoisted_12 = {
  key: 4,
  class: "amount custom-card-destinataire has-text-weight-bold is-size-4"
}
const _hoisted_13 = { key: 5 }
const _hoisted_14 = {
  key: 0,
  class: "frame3-sub-title"
}
const _hoisted_15 = {
  key: 1,
  class: "frame3-sub-title"
}
const _hoisted_16 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_17 = { class: "frame3-sub-title mb-3" }
const _hoisted_18 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_19 = {
  key: 0,
  class: "ml-2 mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", {
        class: _normalizeClass(["modal-card-head", _ctx.$modal.args?.value[0].type])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString({
              transactionDetail: _ctx.$gettext("Transaction details"),
              paymentConfirmation: _ctx.$gettext("Payment confirmation"),
              topup: _ctx.$gettext("Top-up details"),
              reconversion: _ctx.$gettext("Reconversion details"),
            }[_ctx.$modal.args?.value[0].type]), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
        })
      ], 2),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.$modal.args?.value[0]?.source == 'askTopUp')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$gettext(
                "You already have a pending top-up. Please either pay or delete it before proceeding"
              )), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_8, _toDisplayString({
                transactionDetail: _ctx.$modal.args?.value[0].transaction.pending
                  ? _ctx.$gettext("Transaction sent")
                  : _ctx.$gettext("Transaction processed"),
                paymentConfirmation: _ctx.$gettext("Payment sent"),
                topup: _ctx.$gettext("Top-up requested"),
                reconversion: _ctx.$modal.args?.value[0].transaction.pending
                  ? _ctx.$gettext("Reconversion sent")
                  : _ctx.$gettext("Reconversion processed"),
              }[_ctx.$modal.args?.value[0].type]), 1),
          (_ctx.$modal.args?.value[0].type == 'topup')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_fa_icon, {
                  icon: "plus-circle",
                  class: "confirm-icon fa-thin"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_fa_icon, {
                  icon: "fa-check",
                  class: "confirm-icon fa-thin"
                })
              ])),
          (_ctx.$modal.args?.value[0].type != 'topup')
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(((t) =>
                t.amount < 0
                  ? _ctx.$gettext("Sent %{amount}", {
                      amount: `${_ctx.numericFormat(-t.amount)} ${t.currency}`,
                    })
                  : _ctx.$gettext("Received %{amount}", {
                      amount: `${_ctx.numericFormat(t.amount)} ${t.currency}`,
                    }))(_ctx.$modal.args?.value[0].transaction)), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(((t) =>
                _ctx.$gettext("Requested %{amount}", {
                  amount: `${_ctx.numericFormat(t.amount)} ${t.currency}`,
                }))(_ctx.$modal.args?.value[0].transaction)), 1)),
          (_ctx.$modal.args?.value[0].type !== 'reconversion')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.$modal.args?.value[0].type == 'topup')
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_14, _toDisplayString(_ctx.$modal.args?.value[0].transaction.paid
                  ? _ctx.$gettext(
                      "This top-up request is waiting for an administrator of your local currency to validate it"
                    )
                  : _ctx.$gettext(
                      "This top-up request is waiting for you to pay it or delete it"
                    )), 1))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_15, _toDisplayString(_ctx.$modal.args?.value[0].transaction.amount < 0
                  ? _ctx.$gettext("to")
                  : _ctx.$gettext("from")), 1)),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$modal.args?.value[0].transaction.related), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.dateFormat), 1)
        ])
      ]),
      _createElementVNode("footer", _hoisted_18, [
        (
            _ctx.$modal.args?.value[0].type == 'topup' &&
            !_ctx.$modal.args?.value[0].transaction.paid
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "button custom-button-modal has-text-weight-medium",
                id: "delete",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelTopUpRequest && _ctx.cancelTopUpRequest(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Delete")), 1)
              ]),
              _createElementVNode("button", {
                class: "button custom-button-modal has-text-weight-medium",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payTopUpRequest && _ctx.payTopUpRequest(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Pay")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button custom-button-modal has-text-weight-medium",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$modal.close()))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Ok")), 1)
        ])
      ])
    ])
  ]))
}